import styled from "@emotion/styled";

import backgroundMesh from "images/timber-background-mesh_03.png";

export const StyledBackgroundMesh = styled.div`
  background-image: url(${backgroundMesh});
  background-repeat: repeat-x;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
